<template>
  <div class="sdiv dinline-block vtop">
    <div class="est">
      <router-link :to="'/aedu/'+this.action+'/index'" class="more fr tc9 mt5 mr5">更多+</router-link>
      <span class="tt blue prelative dinline-block prelative pb5 fs20 fbold">{{title}}</span>
    </div>
    <div class="cont pt20">
      <Item v-for="(item,index) in infos" v-if="index < 7" :key="index" :index="index" :item="item" :goRoute="goRoute" />
    </div>
  </div>
</template>

<script>
import Item from './item-right'
export default {
  name: "list-right",
  props:[
    'title',
    'action',
    'infos',
  ],
  components: {
    Item,
  },
  methods:{
    goRoute(id){
      let path = `/aedu/${this.action}/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')

      //this.$router.push({path:'/aedu/'+this.action+'/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .est{border-bottom: 1px solid #ddd;}
  .est .tt{margin-bottom: -1px;}
  .est .blue{border-bottom: 1px solid #1787e0;}
</style>



// WEBPACK FOOTER //
// src/components/aedu/index/list-right.vue